import { useInfiniteQuery } from '@tanstack/react-query';
import { fetchComments } from './apiFetchComments';
import { browserClient } from '../../../react-query';
import { GlobalReactQueryOptions } from '../../../config';

const COMMENTS_QUERY_KEY = 'comments';

interface Params {
    listId: string;
    enabled: boolean;
}

export const useComments = ({ listId, enabled }: Params) => {
    const { data, ...rest } = useInfiniteQuery(
        [COMMENTS_QUERY_KEY, listId],
        ({ pageParam = { page: 0, commentId: undefined } }) => {
            return fetchComments(listId, pageParam.page, pageParam.commentId);
        },
        {
            ...GlobalReactQueryOptions,
            enabled,
            staleTime: Infinity,
            keepPreviousData: true,
            getNextPageParam: (lastPage, allPages) => {
                return lastPage.comments.length > 0 ? allPages.length + 1 : undefined;
            }
        }
    );

    return {
        comments: data?.pages.flatMap(page => page.comments) ?? [],
        ...rest
    };
};

export const invalidateComments = (listId: string, commentId?: number) => {
    return browserClient.invalidateQueries({
        queryKey: [COMMENTS_QUERY_KEY, listId, commentId],
        refetchPage: (_, index) => {
            return index === 0;
        }
    });
};
